import React, { useEffect, useState } from "react";
import axios from "axios";
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const API_BASE = `${ENV_API_BASE_URL}/api/courses`;

const EMPTY_BASE = {
  title: "", slug: "", shortTitle: "", category: "",
  homeSections: "", featured: false, homeOrder: 0,
  legacyPath: "", banner: null, bannerUrl: "",
  description: "", duration: "", level: "", location: "", included: "",
};
const EMPTY_CARD       = { title: "", price: "", image: "", formLink: "", link: "" };
const EMPTY_TEACHER    = { images: [""], duration: "", privateRoom: "", sharedRoom: "", certification: "", style: "", path: "" };
const EMPTY_RETREAT    = { title: "", image: "", privatePrice: "", sharedPrice: "", path: "" };
const EMPTY_INFO_CARD  = { title: "", tag: "", detail: "", icon: "" };
const EMPTY_WHY_ITEM   = { icon: "", title: "", description: "" };
const EMPTY_CURRICULUM_ITEM  = { category: "", items: [""] };
const EMPTY_SCHEDULE_ITEM    = { time: "", activity: "" };
const EMPTY_FEATURE_ITEM     = { icon: "", title: "", desc: "" };
const EMPTY_TESTIMONIAL      = { name: "", country: "", text: "" };
const EMPTY_FAQ              = { q: "", a: "" };
const EMPTY_INCLUSION_ITEM   = { icon: "", text: "" };
const EMPTY_ACCOMMODATION_ROOM    = { type: "", description: "" };
const EMPTY_ACCOMMODATION_FEATURE = { label: "", detail: "" };
const EMPTY_ACCOMMODATION = { tag: "", title: "", image: "", rooms: [{ ...EMPTY_ACCOMMODATION_ROOM }], features: [{ ...EMPTY_ACCOMMODATION_FEATURE }] };
const EMPTY_FOOD_MEAL = { meal: "", description: "" };
const EMPTY_FOOD      = { tag: "", title: "", image: "", meals: [{ ...EMPTY_FOOD_MEAL }] };
const EMPTY_WHY_CHOOSE = { tag: "", title: "", image: "", idealForTitle: "", idealFor: [""], benefitsTitle: "", benefits: [""] };

// ── NEW ───────────────────────────────────────────────────────────────────────
const EMPTY_OUR_COURSES_SECTION = {
  tag: "Explore More",
  title: "Our Related Courses",
  description: "",
};

const EMPTY_CONTENT = {
  hero: { quoteText: "", title: "", breadcrumbLabel: "", bannerImage: "" },
  overview: { tag: "", title: "", description: "" },
  infoCards: [{ ...EMPTY_INFO_CARD }],
  whyRishikesh: { tag: "", title: "", description: "", items: [{ ...EMPTY_WHY_ITEM }] },
  curriculum: { tag: "", title: "", items: [{ ...EMPTY_CURRICULUM_ITEM }] },
  dailySchedule: { tag: "", title: "", items: [{ ...EMPTY_SCHEDULE_ITEM }] },
  features: { tag: "", title: "", items: [{ ...EMPTY_FEATURE_ITEM }] },
  included: { tag: "", title: "", includedTitle: "", notIncludedTitle: "", toBringTitle: "", items: [""], notIncluded: [""], toBringImage: "" },
  testimonials: { tag: "", title: "", items: [{ ...EMPTY_TESTIMONIAL }] },
  faqs: { tag: "", title: "", items: [{ ...EMPTY_FAQ }] },
  cta: { title: "", subtitle: "", primaryLabel: "", primaryLink: "", secondaryLabel: "", secondaryLink: "" },
  certificate: {
    hero: { badgeText: "", title: "", subtitle: "", description: "" },
    program: { title: "", duration: "" },
    pricing: { offerBadge: "", regularLabel: "", currentPrice: "", payNotice: "", ctaLabel: "" },
    certification: { title: "", text: "", name: "" },
    eligibility: { title: "", items: [""] },
    inclusions: { title: "", items: [{ ...EMPTY_INCLUSION_ITEM }] },
    location: { title: "", school: "", address: "", description: "", mapSrc: "" },
  },
};

const ensureArray = (value, fallback) =>
  Array.isArray(value) && value.length ? value : fallback;

const cleanStringArray = (items) =>
  (items || []).map((i) => String(i || "").trim()).filter(Boolean);

const cleanObjectArray = (items, fields) =>
  (items || []).map((i) => ({ ...i })).filter((i) =>
    fields.some((f) => String(i[f] || "").trim())
  );

const buildContentState = (content) => {
  const p = content || {};
  return {
    hero: { ...EMPTY_CONTENT.hero, ...(p.hero || {}) },
    overview: { ...EMPTY_CONTENT.overview, ...(p.overview || {}) },
    infoCards: ensureArray(p.infoCards, [{ ...EMPTY_INFO_CARD }]).map((i) => ({ ...EMPTY_INFO_CARD, ...i })),
    whyRishikesh: { ...EMPTY_CONTENT.whyRishikesh, ...(p.whyRishikesh || {}), items: ensureArray(p.whyRishikesh?.items, [{ ...EMPTY_WHY_ITEM }]).map((i) => ({ ...EMPTY_WHY_ITEM, ...i })) },
    curriculum: { ...EMPTY_CONTENT.curriculum, ...(p.curriculum || {}), items: ensureArray(p.curriculum?.items, [{ ...EMPTY_CURRICULUM_ITEM }]).map((i) => ({ category: i.category || "", items: ensureArray(i.items, [""]) })) },
    dailySchedule: { ...EMPTY_CONTENT.dailySchedule, ...(p.dailySchedule || {}), items: ensureArray(p.dailySchedule?.items, [{ ...EMPTY_SCHEDULE_ITEM }]).map((i) => ({ ...EMPTY_SCHEDULE_ITEM, ...i })) },
    features: { ...EMPTY_CONTENT.features, ...(p.features || {}), items: ensureArray(p.features?.items, [{ ...EMPTY_FEATURE_ITEM }]).map((i) => ({ ...EMPTY_FEATURE_ITEM, ...i })) },
    included: { ...EMPTY_CONTENT.included, ...(p.included || {}), items: ensureArray(p.included?.items, [""]), notIncluded: ensureArray(p.included?.notIncluded, [""]) },
    testimonials: { ...EMPTY_CONTENT.testimonials, ...(p.testimonials || {}), items: ensureArray(p.testimonials?.items, [{ ...EMPTY_TESTIMONIAL }]).map((i) => ({ ...EMPTY_TESTIMONIAL, ...i })) },
    faqs: { ...EMPTY_CONTENT.faqs, ...(p.faqs || {}), items: ensureArray(p.faqs?.items, [{ ...EMPTY_FAQ }]).map((i) => ({ ...EMPTY_FAQ, ...i })) },
    cta: { ...EMPTY_CONTENT.cta, ...(p.cta || {}) },
    certificate: {
      hero: { ...EMPTY_CONTENT.certificate.hero, ...(p.certificate?.hero || {}) },
      program: { ...EMPTY_CONTENT.certificate.program, ...(p.certificate?.program || {}) },
      pricing: { ...EMPTY_CONTENT.certificate.pricing, ...(p.certificate?.pricing || {}) },
      certification: { ...EMPTY_CONTENT.certificate.certification, ...(p.certificate?.certification || {}) },
      eligibility: { ...EMPTY_CONTENT.certificate.eligibility, ...(p.certificate?.eligibility || {}), items: ensureArray(p.certificate?.eligibility?.items, [""]) },
      inclusions: { ...EMPTY_CONTENT.certificate.inclusions, ...(p.certificate?.inclusions || {}), items: ensureArray(p.certificate?.inclusions?.items, [{ ...EMPTY_INCLUSION_ITEM }]).map((i) => ({ ...EMPTY_INCLUSION_ITEM, ...i })) },
      location: { ...EMPTY_CONTENT.certificate.location, ...(p.certificate?.location || {}) },
    },
  };
};

const buildAccommodationState = (d) => ({
  tag: d?.tag || "", title: d?.title || "", image: d?.image || "",
  rooms: ensureArray(d?.rooms, [{ ...EMPTY_ACCOMMODATION_ROOM }]).map((r) => ({ ...EMPTY_ACCOMMODATION_ROOM, ...r })),
  features: ensureArray(d?.features, [{ ...EMPTY_ACCOMMODATION_FEATURE }]).map((f) => ({ ...EMPTY_ACCOMMODATION_FEATURE, ...f })),
});

const buildFoodState = (d) => ({
  tag: d?.tag || "", title: d?.title || "", image: d?.image || "",
  meals: ensureArray(d?.meals, [{ ...EMPTY_FOOD_MEAL }]).map((m) => ({ ...EMPTY_FOOD_MEAL, ...m })),
});

const buildWhyChooseState = (d) => ({
  tag: d?.tag || "", title: d?.title || "", image: d?.image || "",
  idealForTitle: d?.idealForTitle || "",
  idealFor: ensureArray(d?.idealFor, [""]),
  benefitsTitle: d?.benefitsTitle || "",
  benefits: ensureArray(d?.benefits, [""]),
});

// ── NEW ───────────────────────────────────────────────────────────────────────
const buildOurCoursesSectionState = (d) => ({
  tag: d?.tag || EMPTY_OUR_COURSES_SECTION.tag,
  title: d?.title || EMPTY_OUR_COURSES_SECTION.title,
  description: d?.description || "",
});

// ─────────────────────────────────────────────────────────────────────────────

function CoursesDetails() {
  const [data, setData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [baseData, setBaseData] = useState(EMPTY_BASE);
  const [cardData, setCardData] = useState(EMPTY_CARD);
  const [teacherData, setTeacherData] = useState(EMPTY_TEACHER);
  const [retreatData, setRetreatData] = useState(EMPTY_RETREAT);
  const [contentData, setContentData] = useState(EMPTY_CONTENT);
  const [accommodationData, setAccommodationData] = useState(EMPTY_ACCOMMODATION);
  const [foodData, setFoodData] = useState(EMPTY_FOOD);
  const [whyChooseData, setWhyChooseData] = useState(EMPTY_WHY_CHOOSE);
  const [ourCoursesSectionData, setOurCoursesSectionData] = useState(EMPTY_OUR_COURSES_SECTION); // NEW

  // Uploaded image files (replace URL fields)
  const [cardImageFile, setCardImageFile] = useState(null);
  const [teacherImageFiles, setTeacherImageFiles] = useState([null]);
  const [retreatImageFile, setRetreatImageFile] = useState(null);
  const [heroBannerImageFile, setHeroBannerImageFile] = useState(null);
  const [toBringImageFile, setToBringImageFile] = useState(null);
  const [accommodationImageFile, setAccommodationImageFile] = useState(null);
  const [foodImageFile, setFoodImageFile] = useState(null);
  const [whyChooseImageFile, setWhyChooseImageFile] = useState(null);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(API_BASE);
      setData(res.data?.data || []);
    } catch { setError("Failed to fetch courses."); }
  };

  const resetForm = () => {
    setBaseData(EMPTY_BASE);
    setCardData(EMPTY_CARD);
    setTeacherData(EMPTY_TEACHER);
    setRetreatData(EMPTY_RETREAT);
    setContentData(EMPTY_CONTENT);
    setAccommodationData(EMPTY_ACCOMMODATION);
    setFoodData(EMPTY_FOOD);
    setWhyChooseData(EMPTY_WHY_CHOOSE);
    setOurCoursesSectionData(EMPTY_OUR_COURSES_SECTION); // NEW
    setCardImageFile(null);
    setTeacherImageFiles([null]);
    setRetreatImageFile(null);
    setHeroBannerImageFile(null);
    setToBringImageFile(null);
    setAccommodationImageFile(null);
    setFoodImageFile(null);
    setWhyChooseImageFile(null);
    setEditId(null);
    setShowForm(false);
    setError("");
  };

  // ── Handlers ──────────────────────────────────────────────────────────────
  const handleBaseChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === "checkbox") setBaseData((p) => ({ ...p, [name]: checked }));
    else if (files) setBaseData((p) => ({ ...p, [name]: files[0] }));
    else setBaseData((p) => ({ ...p, [name]: value }));
  };

  const handleCardChange = (e) => setCardData((p) => ({ ...p, [e.target.name]: e.target.value }));
  const handleTeacherChange = (e) => setTeacherData((p) => ({ ...p, [e.target.name]: e.target.value }));
  const handleRetreatChange = (e) => setRetreatData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleTeacherImageChange = (index, value) =>
    setTeacherData((p) => { const images = [...p.images]; images[index] = value; return { ...p, images }; });
  const addTeacherImage = () => setTeacherData((p) => ({ ...p, images: [...p.images, ""] }));
  const removeTeacherImage = (index) =>
    setTeacherData((p) => { const images = p.images.filter((_, i) => i !== index); return { ...p, images: images.length ? images : [""] }; });

  const setTeacherImageFileAt = (index, file) =>
    setTeacherImageFiles((p) => {
      const next = [...p];
      next[index] = file || null;
      return next;
    });
  const addTeacherImageFile = () => setTeacherImageFiles((p) => [...p, null]);
  const removeTeacherImageFile = (index) =>
    setTeacherImageFiles((p) => {
      const next = p.filter((_, i) => i !== index);
      return next.length ? next : [null];
    });

  const isProbablyUrl = (v) => typeof v === "string" && /^https?:\/\//i.test(v);
  const previewSrc = (file, fallbackUrl) => {
    if (file instanceof File) return URL.createObjectURL(file);
    if (isProbablyUrl(fallbackUrl)) return fallbackUrl;
    return "";
  };

  const updateContentSection = (section, field, value) =>
    setContentData((p) => ({ ...p, [section]: { ...p[section], [field]: value } }));

  const updateInfoCard = (index, field, value) =>
    setContentData((p) => { const infoCards = [...p.infoCards]; infoCards[index] = { ...infoCards[index], [field]: value }; return { ...p, infoCards }; });
  const addInfoCard = () => setContentData((p) => ({ ...p, infoCards: [...p.infoCards, { ...EMPTY_INFO_CARD }] }));
  const removeInfoCard = (index) =>
    setContentData((p) => { const infoCards = p.infoCards.filter((_, i) => i !== index); return { ...p, infoCards: infoCards.length ? infoCards : [{ ...EMPTY_INFO_CARD }] }; });

  const updateNestedItem = (section, index, field, value) =>
    setContentData((p) => { const items = [...p[section].items]; items[index] = { ...items[index], [field]: value }; return { ...p, [section]: { ...p[section], items } }; });
  const addNestedItem = (section, emptyItem) =>
    setContentData((p) => ({ ...p, [section]: { ...p[section], items: [...p[section].items, { ...emptyItem }] } }));
  const removeNestedItem = (section, index, emptyItem) =>
    setContentData((p) => { const items = p[section].items.filter((_, i) => i !== index); return { ...p, [section]: { ...p[section], items: items.length ? items : [{ ...emptyItem }] } }; });

  const updateStringListItem = (section, listKey, index, value) =>
    setContentData((p) => { const items = [...p[section][listKey]]; items[index] = value; return { ...p, [section]: { ...p[section], [listKey]: items } }; });
  const addStringListItem = (section, listKey) =>
    setContentData((p) => ({ ...p, [section]: { ...p[section], [listKey]: [...p[section][listKey], ""] } }));
  const removeStringListItem = (section, listKey, index) =>
    setContentData((p) => { const items = p[section][listKey].filter((_, i) => i !== index); return { ...p, [section]: { ...p[section], [listKey]: items.length ? items : [""] } }; });

  const updateCurriculumCategory = (index, value) =>
    setContentData((p) => { const items = [...p.curriculum.items]; items[index] = { ...items[index], category: value }; return { ...p, curriculum: { ...p.curriculum, items } }; });
  const updateCurriculumItem = (catIdx, itemIdx, value) =>
    setContentData((p) => { const cats = [...p.curriculum.items]; const cat = cats[catIdx]; const items = [...cat.items]; items[itemIdx] = value; cats[catIdx] = { ...cat, items }; return { ...p, curriculum: { ...p.curriculum, items: cats } }; });
  const addCurriculumCategory = () =>
    setContentData((p) => ({ ...p, curriculum: { ...p.curriculum, items: [...p.curriculum.items, { ...EMPTY_CURRICULUM_ITEM }] } }));
  const removeCurriculumCategory = (index) =>
    setContentData((p) => { const items = p.curriculum.items.filter((_, i) => i !== index); return { ...p, curriculum: { ...p.curriculum, items: items.length ? items : [{ ...EMPTY_CURRICULUM_ITEM }] } }; });
  const addCurriculumItem = (catIdx) =>
    setContentData((p) => { const cats = [...p.curriculum.items]; cats[catIdx] = { ...cats[catIdx], items: [...cats[catIdx].items, ""] }; return { ...p, curriculum: { ...p.curriculum, items: cats } }; });
  const removeCurriculumItem = (catIdx, itemIdx) =>
    setContentData((p) => { const cats = [...p.curriculum.items]; const items = cats[catIdx].items.filter((_, i) => i !== itemIdx); cats[catIdx] = { ...cats[catIdx], items: items.length ? items : [""] }; return { ...p, curriculum: { ...p.curriculum, items: cats } }; });

  // Accommodation
  const updateAccommodation = (field, value) => setAccommodationData((p) => ({ ...p, [field]: value }));
  const updateAccommodationRoom = (i, field, value) => setAccommodationData((p) => { const rooms = [...p.rooms]; rooms[i] = { ...rooms[i], [field]: value }; return { ...p, rooms }; });
  const addAccommodationRoom = () => setAccommodationData((p) => ({ ...p, rooms: [...p.rooms, { ...EMPTY_ACCOMMODATION_ROOM }] }));
  const removeAccommodationRoom = (i) => setAccommodationData((p) => { const rooms = p.rooms.filter((_, j) => j !== i); return { ...p, rooms: rooms.length ? rooms : [{ ...EMPTY_ACCOMMODATION_ROOM }] }; });
  const updateAccommodationFeature = (i, field, value) => setAccommodationData((p) => { const features = [...p.features]; features[i] = { ...features[i], [field]: value }; return { ...p, features }; });
  const addAccommodationFeature = () => setAccommodationData((p) => ({ ...p, features: [...p.features, { ...EMPTY_ACCOMMODATION_FEATURE }] }));
  const removeAccommodationFeature = (i) => setAccommodationData((p) => { const features = p.features.filter((_, j) => j !== i); return { ...p, features: features.length ? features : [{ ...EMPTY_ACCOMMODATION_FEATURE }] }; });

  // Food
  const updateFood = (field, value) => setFoodData((p) => ({ ...p, [field]: value }));
  const updateFoodMeal = (i, field, value) => setFoodData((p) => { const meals = [...p.meals]; meals[i] = { ...meals[i], [field]: value }; return { ...p, meals }; });
  const addFoodMeal = () => setFoodData((p) => ({ ...p, meals: [...p.meals, { ...EMPTY_FOOD_MEAL }] }));
  const removeFoodMeal = (i) => setFoodData((p) => { const meals = p.meals.filter((_, j) => j !== i); return { ...p, meals: meals.length ? meals : [{ ...EMPTY_FOOD_MEAL }] }; });

  // Why Choose
  const updateWhyChoose = (field, value) => setWhyChooseData((p) => ({ ...p, [field]: value }));
  const updateWhyChooseList = (listKey, i, value) => setWhyChooseData((p) => { const list = [...p[listKey]]; list[i] = value; return { ...p, [listKey]: list }; });
  const addWhyChooseItem = (listKey) => setWhyChooseData((p) => ({ ...p, [listKey]: [...p[listKey], ""] }));
  const removeWhyChooseItem = (listKey, i) => setWhyChooseData((p) => { const list = p[listKey].filter((_, j) => j !== i); return { ...p, [listKey]: list.length ? list : [""] }; });

  // ── NEW: Our Courses Section ────────────────────────────────────────────────
  const updateOurCourses = (field, value) =>
    setOurCoursesSectionData((p) => ({ ...p, [field]: value }));

  // ── Edit ──────────────────────────────────────────────────────────────────
  const handleEdit = (item) => {
    setBaseData({
      title: item.title || "", slug: item.slug || "", shortTitle: item.shortTitle || "",
      category: item.category || "", homeSections: (item.homeSections || []).join(", "),
      featured: !!item.featured, homeOrder: item.homeOrder || 0,
      legacyPath: item.legacyPath || "", banner: null, bannerUrl: item.banner || "",
      description: item.description || "", duration: item.duration || "",
      level: item.level || "", location: item.location || "", included: item.included || "",
    });
    setCardData({ ...EMPTY_CARD, ...(item.card || {}) });
    setTeacherData({ ...EMPTY_TEACHER, ...(item.teacherTraining || {}), images: ensureArray(item.teacherTraining?.images, [""]) });
    setRetreatData({
      title: item.retreat?.title || item.title || "",
      image: item.retreat?.image || "",
      privatePrice: item.retreat?.privatePrice || "",
      sharedPrice: item.retreat?.sharedPrice || "",
      path: item.retreat?.path || item.legacyPath || "",
    });
    setContentData(buildContentState(item.content));
    setAccommodationData(buildAccommodationState(item.accommodation));
    setFoodData(buildFoodState(item.food));
    setWhyChooseData(buildWhyChooseState(item.whyChoose));
    setOurCoursesSectionData(buildOurCoursesSectionState(item.ourCoursesSection)); // NEW
    setCardImageFile(null);
    setTeacherImageFiles([null]);
    setRetreatImageFile(null);
    setHeroBannerImageFile(null);
    setToBringImageFile(null);
    setAccommodationImageFile(null);
    setFoodImageFile(null);
    setWhyChooseImageFile(null);
    setEditId(item._id);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this course? This will also delete batches and bookings.")) return;
    await axios.delete(`${API_BASE}/${id}`);
    fetchData();
  };

  // ── Payload builders ──────────────────────────────────────────────────────
  const buildContentPayload = () => ({
    hero: { ...contentData.hero },
    overview: { ...contentData.overview },
    infoCards: cleanObjectArray(contentData.infoCards, ["title", "tag", "detail", "icon"]),
    whyRishikesh: { ...contentData.whyRishikesh, items: cleanObjectArray(contentData.whyRishikesh.items, ["icon", "title", "description"]) },
    curriculum: { ...contentData.curriculum, items: (contentData.curriculum.items || []).map((i) => ({ category: String(i.category || "").trim(), items: cleanStringArray(i.items) })).filter((i) => i.category || i.items.length) },
    dailySchedule: { ...contentData.dailySchedule, items: cleanObjectArray(contentData.dailySchedule.items, ["time", "activity"]) },
    features: { ...contentData.features, items: cleanObjectArray(contentData.features.items, ["icon", "title", "desc"]) },
    included: { ...contentData.included, items: cleanStringArray(contentData.included.items), notIncluded: cleanStringArray(contentData.included.notIncluded) },
    testimonials: { ...contentData.testimonials, items: cleanObjectArray(contentData.testimonials.items, ["name", "country", "text"]) },
    faqs: { ...contentData.faqs, items: cleanObjectArray(contentData.faqs.items, ["q", "a"]) },
    cta: { ...contentData.cta },
    certificate: {
      hero: { ...contentData.certificate.hero },
      program: { ...contentData.certificate.program },
      pricing: { ...contentData.certificate.pricing },
      certification: { ...contentData.certificate.certification },
      eligibility: { ...contentData.certificate.eligibility, items: cleanStringArray(contentData.certificate.eligibility.items) },
      inclusions: { ...contentData.certificate.inclusions, items: cleanObjectArray(contentData.certificate.inclusions.items, ["icon", "text"]) },
      location: { ...contentData.certificate.location },
    },
  });

  // ── Submit ────────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const fd = new FormData();
      fd.append("title", baseData.title);
      fd.append("slug", baseData.slug);
      fd.append("shortTitle", baseData.shortTitle);
      fd.append("category", baseData.category);
      fd.append("homeSections", baseData.homeSections);
      fd.append("featured", baseData.featured ? "true" : "false");
      fd.append("homeOrder", String(baseData.homeOrder || 0));
      fd.append("legacyPath", baseData.legacyPath);
      if (baseData.banner) fd.append("banner", baseData.banner);
      else if (baseData.bannerUrl) fd.append("banner", baseData.bannerUrl);
      fd.append("description", baseData.description);
      fd.append("duration", baseData.duration);
      fd.append("level", baseData.level);
      fd.append("location", baseData.location);
      fd.append("included", baseData.included);
      if (cardImageFile) fd.append("cardImage", cardImageFile);
      const teacherFiles = teacherImageFiles.filter((f) => f instanceof File);
      teacherFiles.forEach((f) => fd.append("teacherImages", f));
      if (retreatImageFile) fd.append("retreatImage", retreatImageFile);
      if (heroBannerImageFile) fd.append("heroBannerImage", heroBannerImageFile);
      if (toBringImageFile) fd.append("toBringImage", toBringImageFile);
      if (accommodationImageFile) fd.append("accommodationImage", accommodationImageFile);
      if (foodImageFile) fd.append("foodImage", foodImageFile);
      if (whyChooseImageFile) fd.append("whyChooseImage", whyChooseImageFile);

      fd.append("card", JSON.stringify(cardData));
      fd.append(
        "teacherTraining",
        JSON.stringify({
          ...teacherData,
          images: teacherFiles.length ? [] : cleanStringArray(teacherData.images),
        })
      );
      fd.append("retreat", JSON.stringify(retreatData));
      fd.append("content", JSON.stringify(buildContentPayload()));
      fd.append(
        "accommodation",
        JSON.stringify({
          tag: accommodationData.tag,
          title: accommodationData.title,
          image: accommodationData.image,
          rooms: cleanObjectArray(accommodationData.rooms, ["type", "description"]),
          features: cleanObjectArray(accommodationData.features, ["label", "detail"]),
        })
      );
      fd.append(
        "food",
        JSON.stringify({
          tag: foodData.tag,
          title: foodData.title,
          image: foodData.image,
          meals: cleanObjectArray(foodData.meals, ["meal", "description"]),
        })
      );
      fd.append(
        "whyChoose",
        JSON.stringify({
          tag: whyChooseData.tag,
          title: whyChooseData.title,
          image: whyChooseData.image,
          idealForTitle: whyChooseData.idealForTitle,
          idealFor: cleanStringArray(whyChooseData.idealFor),
          benefitsTitle: whyChooseData.benefitsTitle,
          benefits: cleanStringArray(whyChooseData.benefits),
        })
      );
      fd.append("ourCoursesSection", JSON.stringify(ourCoursesSectionData)); // NEW

      if (editId) await axios.put(`${API_BASE}/${editId}`, fd);
      else await axios.post(API_BASE, fd);

      await fetchData();
      resetForm();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save course.");
    }
    setLoading(false);
  };

  // ─────────────────────────────────────────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────────────────────────────────────────
  const Label = ({ children }) => (
    <label className="text-dark fw-bold form-label">{children}</label>
  );

  return (
    <div className="container pt-5 mt-5">
      <h3 className="mb-4">Courses Catalog</h3>
      {error && <div className="alert alert-danger">{error}</div>}

      {!showForm ? (
        <>
          <button className="btn btn-primary mb-3" onClick={() => setShowForm(true)}>+ Create Course</button>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>S.No</th><th>Title</th><th>Slug</th><th>Category</th>
                <th>Home Sections</th><th>Featured</th><th>Order</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>{item.title}</td>
                  <td>{item.slug}</td>
                  <td>{item.category}</td>
                  <td>{(item.homeSections || []).join(", ")}</td>
                  <td>{item.featured ? "Yes" : "No"}</td>
                  <td>{item.homeOrder || 0}</td>
                  <td>
                    <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(item)}>Edit</button>
                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(item._id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
          <div className="d-flex justify-content-between mb-3">
            <h5>{editId ? "Edit Course" : "Create Course"}</h5>
            <button type="button" className="btn-close" onClick={resetForm} />
          </div>

          {/* ── Basics ───────────────────────────────────────────────────── */}
          <h6 className="mb-3 text-primary">Basics</h6>
          <div className="row">
            <div className="col-md-6 mb-3"><Label>Course name (shown in form)</Label><input type="text" name="shortTitle" className="form-control" value={baseData.shortTitle} onChange={handleBaseChange} /></div>
            <div className="col-md-6 mb-3"><Label>Slug</Label><input type="text" name="slug" className="form-control" value={baseData.slug} onChange={handleBaseChange} placeholder="auto-generated if left blank" /></div>
            <div className="col-md-6 mb-3">
              <Label>Homepage Sections</Label>
              <input
                type="text"
                name="homeSections"
                className="form-control"
                value={baseData.homeSections}
                onChange={handleBaseChange}
                placeholder="top-courses, teacher-training, retreat"
              />
              <div className="form-text">
                Use comma-separated section ids. Example: <code>retreat</code> to show the course in the Yoga Retreat homepage block.
              </div>
            </div>
            <div className="col-md-3 mb-3"><Label>Home Order</Label><input type="number" name="homeOrder" className="form-control" value={baseData.homeOrder} onChange={handleBaseChange} /></div>
            <div className="col-md-3 mb-3 d-flex align-items-end">
              <div className="form-check">
                <input type="checkbox" className="form-check-input" id="featured" name="featured" checked={baseData.featured} onChange={handleBaseChange} />
                <label className="text-dark fw-bold form-check-label" htmlFor="featured">Featured</label>
              </div>
            </div>
            <div className="col-md-6 mb-3"><Label>Legacy Path</Label><input type="text" name="legacyPath" className="form-control" value={baseData.legacyPath} onChange={handleBaseChange} placeholder="/YogaCourse100" /></div>
          </div>

          {/* ── Banner ───────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Banner</h6>
          <div className="row">
            <div className="col-md-6 mb-3"><Label>Banner URL</Label><input type="text" name="bannerUrl" className="form-control" value={baseData.bannerUrl} onChange={handleBaseChange} /></div>
            <div className="col-md-6 mb-3"><Label>Banner Upload</Label><input type="file" name="banner" className="form-control" onChange={handleBaseChange} /></div>
          </div>

          {/* ── Core Details ─────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Core Details</h6>
          <div className="row">
            <div className="col-md-6 mb-3"><Label>Duration</Label><input type="text" name="duration" className="form-control" value={baseData.duration} onChange={handleBaseChange} /></div>
            <div className="col-md-6 mb-3"><Label>Level</Label><input type="text" name="level" className="form-control" value={baseData.level} onChange={handleBaseChange} /></div>
            <div className="col-md-6 mb-3"><Label>Location</Label><input type="text" name="location" className="form-control" value={baseData.location} onChange={handleBaseChange} /></div>
          </div>
          <div className="mb-3"><Label>Description</Label><textarea className="form-control" rows={3} name="description" value={baseData.description} onChange={handleBaseChange} /></div>
          <div className="mb-3"><Label>Included (Text)</Label><textarea className="form-control" rows={3} name="included" value={baseData.included} onChange={handleBaseChange} /></div>

          {/* ── Card ─────────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Homepage Course Card</h6>
          <div className="row">
            <div className="col-md-6 mb-3"><Label>Category (id)</Label><input type="text" name="category" className="form-control" value={baseData.category} onChange={handleBaseChange} /></div>
            <div className="col-md-6 mb-3"><Label>Card Title</Label><input type="text" name="title" className="form-control" value={cardData.title} onChange={handleCardChange} /></div>
            <div className="col-md-6 mb-3"><Label>Card Price</Label><input type="text" name="price" className="form-control" value={cardData.price} onChange={handleCardChange} /></div>
            <div className="col-md-6 mb-3">
              <Label>Card Image Upload</Label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setCardImageFile(e.target.files?.[0] || null)}
              />
              {previewSrc(cardImageFile, cardData.image) && (
                <img
                  src={previewSrc(cardImageFile, cardData.image)}
                  alt="Card preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
            <div className="col-md-6 mb-3"><Label>Card Link</Label><input type="text" name="link" className="form-control" value={cardData.link} onChange={handleCardChange} /></div>
            <div className="col-md-6 mb-3"><Label>Card Form Link</Label><input type="text" name="formLink" className="form-control" value={cardData.formLink} onChange={handleCardChange} /></div>
          </div>

          {/* ── Teacher Training ──────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Teacher Training Card</h6>
          <div className="row">
            <div className="col-md-6 mb-3"><Label>Title</Label><input type="text" name="title" className="form-control" value={baseData.title} onChange={handleBaseChange} required /></div>
            <div className="col-md-6 mb-3"><Label>Duration</Label><input type="text" name="duration" className="form-control" value={teacherData.duration} onChange={handleTeacherChange} /></div>
            <div className="col-md-6 mb-3"><Label>Certification</Label><input type="text" name="certification" className="form-control" value={teacherData.certification} onChange={handleTeacherChange} /></div>
            <div className="col-md-6 mb-3"><Label>Private Room</Label><input type="text" name="privateRoom" className="form-control" value={teacherData.privateRoom} onChange={handleTeacherChange} /></div>
            <div className="col-md-6 mb-3"><Label>Shared Room</Label><input type="text" name="sharedRoom" className="form-control" value={teacherData.sharedRoom} onChange={handleTeacherChange} /></div>
            <div className="col-md-6 mb-3"><Label>Style</Label><input type="text" name="style" className="form-control" value={teacherData.style} onChange={handleTeacherChange} /></div>
            <div className="col-md-6 mb-3"><Label>Details Path</Label><input type="text" name="path" className="form-control" value={teacherData.path} onChange={handleTeacherChange} /></div>
          </div>
          <Label>Teacher Training Images</Label>
          <div className="alert alert-secondary py-2 small">
            Existing images will remain unless you upload new files here.
          </div>
          {teacherImageFiles.map((file, i) => (
            <div key={i} className="border rounded p-2 mb-2">
              <div className="d-flex gap-2 align-items-start">
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => setTeacherImageFileAt(i, e.target.files?.[0] || null)}
                />
                <button type="button" className="btn btn-outline-danger" onClick={() => removeTeacherImageFile(i)}>
                  Remove
                </button>
              </div>
              {file instanceof File && (
                <img
                  src={previewSrc(file, "")}
                  alt="Teacher preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary mb-3" onClick={addTeacherImageFile}>+ Add Image</button>

          {/* ── Retreat ──────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Retreat Card</h6>
          <div className="row">
            <div className="col-md-6 mb-3">
              <Label>Retreat Title</Label>
              <input
                type="text"
                name="title"
                className="form-control"
                value={retreatData.title}
                onChange={handleRetreatChange}
                placeholder="5 Days Yoga Retreat"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Label>Retreat Details Path</Label>
              <input
                type="text"
                name="path"
                className="form-control"
                value={retreatData.path}
                onChange={handleRetreatChange}
                placeholder="/5-days-yoga-retreat"
              />
            </div>
            <div className="col-md-6 mb-3">
              <Label>Retreat Image Upload</Label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setRetreatImageFile(e.target.files?.[0] || null)}
              />
              {previewSrc(retreatImageFile, retreatData.image) && (
                <img
                  src={previewSrc(retreatImageFile, retreatData.image)}
                  alt="Retreat preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
            <div className="col-md-3 mb-3">
              <Label>Private Stay Price</Label>
              <input
                type="text"
                name="privatePrice"
                className="form-control"
                value={retreatData.privatePrice}
                onChange={handleRetreatChange}
              />
            </div>
            <div className="col-md-3 mb-3">
              <Label>Shared Stay Price</Label>
              <input
                type="text"
                name="sharedPrice"
                className="form-control"
                value={retreatData.sharedPrice}
                onChange={handleRetreatChange}
              />
            </div>
          </div>
          <div className="alert alert-info py-2 small">
            Add <code>retreat</code> to Homepage Sections above to show this course in the homepage retreat cards.
          </div>

          {/* ── Hero ─────────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Main Course Page — Hero</h6>
          <div className="row">
            <div className="col-md-6 mb-3"><Label>Quote Text</Label><input type="text" className="form-control" value={contentData.hero.quoteText} onChange={(e) => updateContentSection("hero", "quoteText", e.target.value)} /></div>
            <div className="col-md-6 mb-3"><Label>Hero Title</Label><input type="text" className="form-control" value={contentData.hero.title} onChange={(e) => updateContentSection("hero", "title", e.target.value)} /></div>
            <div className="col-md-6 mb-3"><Label>Breadcrumb Label</Label><input type="text" className="form-control" value={contentData.hero.breadcrumbLabel} onChange={(e) => updateContentSection("hero", "breadcrumbLabel", e.target.value)} /></div>
            <div className="col-md-6 mb-3">
              <Label>Banner Image Upload</Label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setHeroBannerImageFile(e.target.files?.[0] || null)}
              />
              {previewSrc(heroBannerImageFile, contentData.hero.bannerImage) && (
                <img
                  src={previewSrc(heroBannerImageFile, contentData.hero.bannerImage)}
                  alt="Hero preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
          </div>

          {/* ── Overview ─────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Overview</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.overview.tag} onChange={(e) => updateContentSection("overview", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.overview.title} onChange={(e) => updateContentSection("overview", "title", e.target.value)} /></div>
          </div>
          <div className="mb-3"><Label>Description</Label><textarea className="form-control" rows={3} value={contentData.overview.description} onChange={(e) => updateContentSection("overview", "description", e.target.value)} /></div>

          {/* ── Info Cards ───────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Info Cards</h6>
          {contentData.infoCards.map((card, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-3 mb-2"><Label>Title</Label><input type="text" className="form-control" value={card.title} onChange={(e) => updateInfoCard(i, "title", e.target.value)} /></div>
                <div className="col-md-3 mb-2"><Label>Tag</Label><input type="text" className="form-control" value={card.tag} onChange={(e) => updateInfoCard(i, "tag", e.target.value)} /></div>
                <div className="col-md-4 mb-2"><Label>Detail</Label><input type="text" className="form-control" value={card.detail} onChange={(e) => updateInfoCard(i, "detail", e.target.value)} /></div>
                <div className="col-md-2 mb-2"><Label>Icon</Label><input type="text" className="form-control" value={card.icon} onChange={(e) => updateInfoCard(i, "icon", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeInfoCard(i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={addInfoCard}>+ Add Info Card</button>

          {/* ── Why Rishikesh ─────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Why Rishikesh</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.whyRishikesh.tag} onChange={(e) => updateContentSection("whyRishikesh", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.whyRishikesh.title} onChange={(e) => updateContentSection("whyRishikesh", "title", e.target.value)} /></div>
          </div>
          <div className="mb-3"><Label>Description</Label><textarea className="form-control" rows={3} value={contentData.whyRishikesh.description} onChange={(e) => updateContentSection("whyRishikesh", "description", e.target.value)} /></div>
          {contentData.whyRishikesh.items.map((item, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-2 mb-2"><Label>Icon</Label><input type="text" className="form-control" value={item.icon} onChange={(e) => updateNestedItem("whyRishikesh", i, "icon", e.target.value)} /></div>
                <div className="col-md-4 mb-2"><Label>Title</Label><input type="text" className="form-control" value={item.title} onChange={(e) => updateNestedItem("whyRishikesh", i, "title", e.target.value)} /></div>
                <div className="col-md-6 mb-2"><Label>Description</Label><input type="text" className="form-control" value={item.description} onChange={(e) => updateNestedItem("whyRishikesh", i, "description", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeNestedItem("whyRishikesh", i, EMPTY_WHY_ITEM)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={() => addNestedItem("whyRishikesh", EMPTY_WHY_ITEM)}>+ Add Why Item</button>

          {/* ── Curriculum ───────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Curriculum</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.curriculum.tag} onChange={(e) => updateContentSection("curriculum", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.curriculum.title} onChange={(e) => updateContentSection("curriculum", "title", e.target.value)} /></div>
          </div>
          {contentData.curriculum.items.map((item, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <Label>Category</Label>
              <input type="text" className="form-control mb-2" value={item.category} onChange={(e) => updateCurriculumCategory(i, e.target.value)} />
              <Label>Items</Label>
              {item.items.map((entry, j) => (
                <div key={j} className="d-flex gap-2 mb-2">
                  <input type="text" className="form-control" value={entry} onChange={(e) => updateCurriculumItem(i, j, e.target.value)} />
                  <button type="button" className="btn btn-outline-danger" onClick={() => removeCurriculumItem(i, j)}>Remove</button>
                </div>
              ))}
              <button type="button" className="btn btn-outline-primary" onClick={() => addCurriculumItem(i)}>+ Add Item</button>
              <button type="button" className="btn btn-outline-danger ms-2" onClick={() => removeCurriculumCategory(i)}>Remove Category</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={addCurriculumCategory}>+ Add Category</button>

          {/* ── Daily Schedule ───────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Daily Schedule</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.dailySchedule.tag} onChange={(e) => updateContentSection("dailySchedule", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.dailySchedule.title} onChange={(e) => updateContentSection("dailySchedule", "title", e.target.value)} /></div>
          </div>
          {contentData.dailySchedule.items.map((item, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-4 mb-2"><Label>Time</Label><input type="text" className="form-control" value={item.time} onChange={(e) => updateNestedItem("dailySchedule", i, "time", e.target.value)} /></div>
                <div className="col-md-8 mb-2"><Label>Activity</Label><input type="text" className="form-control" value={item.activity} onChange={(e) => updateNestedItem("dailySchedule", i, "activity", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeNestedItem("dailySchedule", i, EMPTY_SCHEDULE_ITEM)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={() => addNestedItem("dailySchedule", EMPTY_SCHEDULE_ITEM)}>+ Add Schedule Item</button>

          {/* ── Features ─────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Features</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.features.tag} onChange={(e) => updateContentSection("features", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.features.title} onChange={(e) => updateContentSection("features", "title", e.target.value)} /></div>
          </div>
          {contentData.features.items.map((item, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-2 mb-2"><Label>Icon</Label><input type="text" className="form-control" value={item.icon} onChange={(e) => updateNestedItem("features", i, "icon", e.target.value)} /></div>
                <div className="col-md-4 mb-2"><Label>Title</Label><input type="text" className="form-control" value={item.title} onChange={(e) => updateNestedItem("features", i, "title", e.target.value)} /></div>
                <div className="col-md-6 mb-2"><Label>Description</Label><input type="text" className="form-control" value={item.desc} onChange={(e) => updateNestedItem("features", i, "desc", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeNestedItem("features", i, EMPTY_FEATURE_ITEM)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={() => addNestedItem("features", EMPTY_FEATURE_ITEM)}>+ Add Feature</button>

          {/* ── Included ─────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Included Section</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.included.tag} onChange={(e) => updateContentSection("included", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.included.title} onChange={(e) => updateContentSection("included", "title", e.target.value)} /></div>
          </div>
          <div className="col-md-4 mb-3"><Label>Included Heading</Label><input type="text" className="form-control" value={contentData.included.includedTitle} onChange={(e) => updateContentSection("included", "includedTitle", e.target.value)} /></div>
          <Label>Included Items</Label>
          {contentData.included.items.map((item, i) => (
            <div key={i} className="d-flex gap-2 mb-2">
              <input type="text" className="form-control" value={item} onChange={(e) => updateStringListItem("included", "items", i, e.target.value)} />
              <button type="button" className="btn btn-outline-danger" onClick={() => removeStringListItem("included", "items", i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary mb-3" onClick={() => addStringListItem("included", "items")}>+ Add Included Item</button>
          <div className="col-md-4 mb-3"><Label>Not Included Heading</Label><input type="text" className="form-control" value={contentData.included.notIncludedTitle} onChange={(e) => updateContentSection("included", "notIncludedTitle", e.target.value)} /></div>
          <Label>Not Included Items</Label>
          {contentData.included.notIncluded.map((item, i) => (
            <div key={i} className="d-flex gap-2 mb-2">
              <input type="text" className="form-control" value={item} onChange={(e) => updateStringListItem("included", "notIncluded", i, e.target.value)} />
              <button type="button" className="btn btn-outline-danger" onClick={() => removeStringListItem("included", "notIncluded", i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary mb-3" onClick={() => addStringListItem("included", "notIncluded")}>+ Add Not Included Item</button>
          <div className="row">
            <div className="col-md-6"><Label>To Bring Heading</Label><input type="text" className="form-control" value={contentData.included.toBringTitle} onChange={(e) => updateContentSection("included", "toBringTitle", e.target.value)} /></div>
            <div className="col-md-6">
              <Label>To Bring Image Upload</Label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setToBringImageFile(e.target.files?.[0] || null)}
              />
              {previewSrc(toBringImageFile, contentData.included.toBringImage) && (
                <img
                  src={previewSrc(toBringImageFile, contentData.included.toBringImage)}
                  alt="To bring preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
          </div>

          {/* ── Testimonials ─────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">Testimonials</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.testimonials.tag} onChange={(e) => updateContentSection("testimonials", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.testimonials.title} onChange={(e) => updateContentSection("testimonials", "title", e.target.value)} /></div>
          </div>
          {contentData.testimonials.items.map((item, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-4 mb-2"><Label>Name</Label><input type="text" className="form-control" value={item.name} onChange={(e) => updateNestedItem("testimonials", i, "name", e.target.value)} /></div>
                <div className="col-md-4 mb-2"><Label>Country</Label><input type="text" className="form-control" value={item.country} onChange={(e) => updateNestedItem("testimonials", i, "country", e.target.value)} /></div>
                <div className="col-md-12 mb-2"><Label>Text</Label><textarea className="form-control" rows={2} value={item.text} onChange={(e) => updateNestedItem("testimonials", i, "text", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeNestedItem("testimonials", i, EMPTY_TESTIMONIAL)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={() => addNestedItem("testimonials", EMPTY_TESTIMONIAL)}>+ Add Testimonial</button>

          {/* ── FAQs ─────────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">FAQs</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={contentData.faqs.tag} onChange={(e) => updateContentSection("faqs", "tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.faqs.title} onChange={(e) => updateContentSection("faqs", "title", e.target.value)} /></div>
          </div>
          {contentData.faqs.items.map((item, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <Label>Question</Label>
              <input type="text" className="form-control mb-2" value={item.q} onChange={(e) => updateNestedItem("faqs", i, "q", e.target.value)} />
              <Label>Answer</Label>
              <textarea className="form-control" rows={2} value={item.a} onChange={(e) => updateNestedItem("faqs", i, "a", e.target.value)} />
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeNestedItem("faqs", i, EMPTY_FAQ)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={() => addNestedItem("faqs", EMPTY_FAQ)}>+ Add FAQ</button>

          {/* ── CTA ──────────────────────────────────────────────────────── */}
          <h6 className="mt-4 mb-3 text-primary">CTA Section</h6>
          <div className="row">
            <div className="col-md-6 mb-3"><Label>Title</Label><input type="text" className="form-control" value={contentData.cta.title} onChange={(e) => updateContentSection("cta", "title", e.target.value)} /></div>
            <div className="col-md-6 mb-3"><Label>Subtitle</Label><input type="text" className="form-control" value={contentData.cta.subtitle} onChange={(e) => updateContentSection("cta", "subtitle", e.target.value)} /></div>
            <div className="col-md-6 mb-3"><Label>Primary Label</Label><input type="text" className="form-control" value={contentData.cta.primaryLabel} onChange={(e) => updateContentSection("cta", "primaryLabel", e.target.value)} /></div>
            <div className="col-md-6 mb-3"><Label>Primary Link</Label><input type="text" className="form-control" value={contentData.cta.primaryLink} onChange={(e) => updateContentSection("cta", "primaryLink", e.target.value)} /></div>
            <div className="col-md-6 mb-3"><Label>Secondary Label</Label><input type="text" className="form-control" value={contentData.cta.secondaryLabel} onChange={(e) => updateContentSection("cta", "secondaryLink", e.target.value)} /></div>
            <div className="col-md-6 mb-3"><Label>Secondary Link</Label><input type="text" className="form-control" value={contentData.cta.secondaryLink} onChange={(e) => updateContentSection("cta", "secondaryLink", e.target.value)} /></div>
          </div>

          {/* ── Accommodation ────────────────────────────────────────────── */}
          <h6 className="mt-5 mb-3 text-primary border-top pt-4">Accommodation</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={accommodationData.tag} onChange={(e) => updateAccommodation("tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={accommodationData.title} onChange={(e) => updateAccommodation("title", e.target.value)} /></div>
            <div className="col-12 mb-3">
              <Label>Image Upload</Label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setAccommodationImageFile(e.target.files?.[0] || null)}
              />
              {previewSrc(accommodationImageFile, accommodationData.image) && (
                <img
                  src={previewSrc(accommodationImageFile, accommodationData.image)}
                  alt="Accommodation preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
          </div>
          <Label>Room Types</Label>
          {accommodationData.rooms.map((room, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-4 mb-2"><Label>Type</Label><input type="text" className="form-control" placeholder="e.g. Shared Rooms" value={room.type} onChange={(e) => updateAccommodationRoom(i, "type", e.target.value)} /></div>
                <div className="col-md-8 mb-2"><Label>Description</Label><input type="text" className="form-control" value={room.description} onChange={(e) => updateAccommodationRoom(i, "description", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeAccommodationRoom(i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary mb-4" onClick={addAccommodationRoom}>+ Add Room Type</button>
          <Label>Facility Highlights</Label>
          {accommodationData.features.map((feat, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-4 mb-2"><Label>Label</Label><input type="text" className="form-control" placeholder="e.g. Room Features" value={feat.label} onChange={(e) => updateAccommodationFeature(i, "label", e.target.value)} /></div>
                <div className="col-md-8 mb-2"><Label>Detail</Label><input type="text" className="form-control" value={feat.detail} onChange={(e) => updateAccommodationFeature(i, "detail", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeAccommodationFeature(i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={addAccommodationFeature}>+ Add Facility</button>

          {/* ── Food ─────────────────────────────────────────────────────── */}
          <h6 className="mt-5 mb-3 text-primary border-top pt-4">Food</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={foodData.tag} onChange={(e) => updateFood("tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={foodData.title} onChange={(e) => updateFood("title", e.target.value)} /></div>
            <div className="col-12 mb-3">
              <Label>Image Upload</Label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setFoodImageFile(e.target.files?.[0] || null)}
              />
              {previewSrc(foodImageFile, foodData.image) && (
                <img
                  src={previewSrc(foodImageFile, foodData.image)}
                  alt="Food preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
          </div>
          <Label>Meals</Label>
          {foodData.meals.map((meal, i) => (
            <div key={i} className="border rounded p-3 mb-3">
              <div className="row">
                <div className="col-md-4 mb-2"><Label>Meal</Label><input type="text" className="form-control" placeholder="e.g. Breakfast" value={meal.meal} onChange={(e) => updateFoodMeal(i, "meal", e.target.value)} /></div>
                <div className="col-md-8 mb-2"><Label>Description</Label><input type="text" className="form-control" value={meal.description} onChange={(e) => updateFoodMeal(i, "description", e.target.value)} /></div>
              </div>
              <button type="button" className="btn btn-outline-danger mt-2" onClick={() => removeFoodMeal(i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={addFoodMeal}>+ Add Meal</button>

          {/* ── Why Choose ───────────────────────────────────────────────── */}
          <h6 className="mt-5 mb-3 text-primary border-top pt-4">Why Choose This Course?</h6>
          <div className="row">
            <div className="col-md-4 mb-3"><Label>Tag</Label><input type="text" className="form-control" value={whyChooseData.tag} onChange={(e) => updateWhyChoose("tag", e.target.value)} /></div>
            <div className="col-md-8 mb-3"><Label>Title</Label><input type="text" className="form-control" value={whyChooseData.title} onChange={(e) => updateWhyChoose("title", e.target.value)} /></div>
            <div className="col-12 mb-3">
              <Label>Image Upload</Label>
              <input
                type="file"
                className="form-control"
                accept="image/*"
                onChange={(e) => setWhyChooseImageFile(e.target.files?.[0] || null)}
              />
              {previewSrc(whyChooseImageFile, whyChooseData.image) && (
                <img
                  src={previewSrc(whyChooseImageFile, whyChooseData.image)}
                  alt="Why choose preview"
                  className="mt-2 rounded border"
                  style={{ width: "100%", maxWidth: 260, height: 150, objectFit: "cover" }}
                />
              )}
            </div>
          </div>
          <div className="mb-3"><Label>Ideal For — Section Heading</Label><input type="text" className="form-control" value={whyChooseData.idealForTitle} onChange={(e) => updateWhyChoose("idealForTitle", e.target.value)} /></div>
          <Label>Ideal For Items</Label>
          {whyChooseData.idealFor.map((item, i) => (
            <div key={i} className="d-flex gap-2 mb-2">
              <input type="text" className="form-control" value={item} onChange={(e) => updateWhyChooseList("idealFor", i, e.target.value)} />
              <button type="button" className="btn btn-outline-danger" onClick={() => removeWhyChooseItem("idealFor", i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary mb-4" onClick={() => addWhyChooseItem("idealFor")}>+ Add Ideal For Item</button>
          <div className="mb-3"><Label>Benefits — Section Heading</Label><input type="text" className="form-control" value={whyChooseData.benefitsTitle} onChange={(e) => updateWhyChoose("benefitsTitle", e.target.value)} /></div>
          <Label>Benefits Items</Label>
          {whyChooseData.benefits.map((item, i) => (
            <div key={i} className="d-flex gap-2 mb-2">
              <input type="text" className="form-control" value={item} onChange={(e) => updateWhyChooseList("benefits", i, e.target.value)} />
              <button type="button" className="btn btn-outline-danger" onClick={() => removeWhyChooseItem("benefits", i)}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn btn-outline-primary" onClick={() => addWhyChooseItem("benefits")}>+ Add Benefit</button>

          {/* ══════════════════════════════════════════════════════════════════
              NEW — Our Courses Section
          ══════════════════════════════════════════════════════════════════ */}
          <h6 className="mt-5 mb-2 text-primary border-top pt-4">Our Courses Section</h6>
          <p className="text-muted small mb-3">
            Controls the heading of the "related courses" block on the course page.
            Cards are populated automatically from other courses in the same category — no manual card entry needed.
          </p>
          <div className="row">
            <div className="col-md-4 mb-3">
              <Label>Tag</Label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g. Explore More"
                value={ourCoursesSectionData.tag}
                onChange={(e) => updateOurCourses("tag", e.target.value)}
              />
            </div>
            <div className="col-md-8 mb-3">
              <Label>Title</Label>
              <input
                type="text"
                className="form-control"
                placeholder="e.g. Our Related Courses"
                value={ourCoursesSectionData.title}
                onChange={(e) => updateOurCourses("title", e.target.value)}
              />
            </div>
            <div className="col-12 mb-3">
              <Label>Description (optional)</Label>
              <textarea
                className="form-control"
                rows={2}
                placeholder="A short sentence shown below the heading…"
                value={ourCoursesSectionData.description}
                onChange={(e) => updateOurCourses("description", e.target.value)}
              />
            </div>
          </div>
          <div className="alert alert-info py-2 small">
            <strong>How it works:</strong> The cards displayed in this section are fetched live from the database — all courses with the same <em>category</em> as this course, excluding the current course. Set the category correctly in the <strong>Homepage Course Card</strong> section above to control which courses appear here.
          </div>

          {/* ── Submit ───────────────────────────────────────────────────── */}
          <div className="d-flex gap-2 mt-5">
            <button className="btn btn-success" disabled={loading}>{loading ? "Saving..." : editId ? "Update" : "Save"}</button>
            <button type="button" className="btn btn-secondary" onClick={resetForm}>Cancel</button>
          </div>
        </form>
      )}
    </div>
  );
}

export default CoursesDetails;
